import { render, staticRenderFns } from "./QuantityButton.vue?vue&type=template&id=24828c04&scoped=true"
import script from "./QuantityButton.vue?vue&type=script&lang=js"
export * from "./QuantityButton.vue?vue&type=script&lang=js"
import style0 from "./QuantityButton.vue?vue&type=style&index=0&id=24828c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24828c04",
  null
  
)

export default component.exports